import React , {useState , useEffect} from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { getPayInTransactionReports,getPayInTransactionReportsExcel ,getPayInReportsEnquiry } from '../../api/login/Login'
import { useParams } from 'react-router-dom'
import { Formik, Form, Field } from 'formik';
import { ToastContainer } from 'react-toastify'
import { message, Pagination ,Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx'; 
import Loadar from '../../common/loader/Loader'
import CustomInputField from '../../common/CustomInputField'

const breadCrumbsTitle = {
        id: "1",
        title_1: 'Reports',
        title_2:  'PayIn Transaction Reports',
      }


const PayInTransactionReport = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [count , setCount] = useState(10)
      const [data, setData] = useState(null);
      const [loading , setLoading] = useState(false)
    const [formKey, setFormKey] = useState(0);
    const [totalAmount , setTotalAmount] = useState(0)
    const [totalCount , setTotalCount] = useState(0)
    const [resetKey , setResetKey] = useState(false)
    const defaultInitialValues = {
        orderId : '',
        start_date: '',
        end_date: '',
        txn_id: '',
    };
    const resetValues = {
        orderId : '',
        start_date: '',
        end_date: '',
        txn_id: '',
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);
 

    

     

        const handleReset = (resetForm) => {
            resetForm();
            setInitialValues(resetValues);
            setFormKey(prev => prev + 1); 
            setCurrentPage(1)
            setResetKey((pre)=>!pre)
            // getDmtTxnData(0); 
        };

        const handleSubmit = (values) => {
            console.log("fire")
            setCurrentPage(1)
            setInitialValues(values)
            setResetKey((pre)=>!pre)
            // Add your API call here
        };

        const onChangeVal = (page) => {
            setResetKey((pre)=>!pre)
            setCurrentPage(page);
           
        };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getPayInTransactionReports({ 
        ...initialValues, 
        page: currentPage, 
        count,
      
      });
      if (res && res.data) {
        setData(res?.data);
        setTotalAmount(res?.totalAmount)
        setTotalCount(res?.totalCount)
      } else {
        setData(null);
        setTotalAmount(0)
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };


    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getPayInTransactionReportsExcel({
          ...initialValues,
         
        });
        
        if (res && res.data && res.data?.length > 0) {
       const dataForExcel = res.data.map((item, i) => ({
        "Sr. No": i + 1,
        "Created At": item?.createdAt,
        "Merchant Order ID": item?.merchantOrderId,
        "Order ID": item?.orderId,
        "Opening Balance": item?.o_bal ?? '--',
        "Amount": item?.amount ?? '--',
        "Charges": item?.charges ?? '--',
        "Tax on Charges": item?.taxOnCharge ?? '--',
        "Final Amount": item?.final_amount ?? '--',
        "Closing Balance": item?.c_bal ?? '--',
        "Status":
          item?.status === '1'
            ? 'Pending'
            : item?.status === '2'
            ? 'Success'
            : item?.status === '3'
            ? 'Failed'
            : item?.status === '4'
            ? 'Refund'
            : 'Unknown',
        "User Name": item?.user_name,
        "User Mobile": item?.userMobileNo,
        "User Merchant Code": item?.user_merchant_code,
      }));
  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "PayInTrasactionReport");
          XLSX.writeFile(wb, `PayInTrasactionReport ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    //   const responseEnquiry = async (id) => {
    //     setLoading(true); // Start loader before API call
    //     try {
    //         const res = await getPayInReportsEnquiry(id);
           
    //         if (res?.data?.statusCode == "200") {
    //             message.success(res?.data?.message || res?.message );
                
    //         } else if (res?.data?.statusCode == "300") {
    //             message.info(res?.message || res?.data?.message );
               
    //         } else {
    //             message.error(res?.message || res?.data?.message);
                
    //         }
    //     } catch (error) {
    //         console.error("Error in payment enquiry:", error);
    //         message.error("An error occurred while processing your request");
    //     } finally {
    //         setResetKey((pre)=>!pre)
    //         setLoading(false); 
    //     }
    // };


  useEffect(()=>{
    getData()
  },[resetKey , currentPage])

  return (
    <>
    { loading && <Loadar/> }
      <ToastContainer />

    
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    
    {/* // Filter Option // */}
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} Search</b></h4>
                            </div>
                            <Formik
                                  key={formKey}
                                  initialValues={initialValues}
                                  onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ errors, touched, resetForm }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="start_date"
                                                    placeholder="Start Date"
                                                    hasError={touched.start_date && errors.start_date}
                                                    errorMsg={errors.start_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="end_date"
                                                    placeholder="End Date"
                                                    hasError={touched.end_date && errors.end_date}
                                                    errorMsg={errors.end_date}
                                                />
                                            </div>
                                           
                                            
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="orderId"
                                                    placeholder="Order ID"
                                                    hasError={touched.orderId && errors.orderId}
                                                    errorMsg={errors.orderId}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="d-flex justify-content-start">
                                                    <button className="btn btn-primary me-2" type="submit">
                                                        <i className="fas fa-search"></i> Search
                                                    </button>
                                                    <btn className="btn btn-secondary" type="button" onClick={() => handleReset(resetForm)}>
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </btn>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/* // filter option end here  */}


    {/* // table section  */}
    {data?.length > 0 ? (
        <>
         <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} List</b></h4>
                                        <div className='d-flex'>
                                           
                                            <button onClick={downloadExcel} className='btn btn-primary border border-white'> <DownloadOutlined /> Download Excel</button>
                                        </div>
                                      

                                    </div>
                                       <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{totalAmount || 0}</b></h3>
                                </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer"> 
    <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
        <thead>
          <tr role="row">
  <th>Sr. No</th>
  <th>Date / Time</th>
  <th>Merchant Order ID</th>
  <th>Order ID</th>
   <th>Opening Balance</th>
  <th>Amount</th>
   <th>Charge</th>
    <th>Tax on Charge</th>
     <th>Final Amount</th>
  <th>Closing Balance</th>
   <th>Status</th>
  <th>User Name</th>
        <th>User Mobile</th>
        <th>User Code</th>
  {/* <th>Enquiry</th> */}
</tr>
        </thead>
        <tbody>
            {data?.map((item, i) => (
                <tr key={i} role="row" className="odd">
                    <td>{i + 1}</td> 
  <td>{item?.createdAt}</td> 
  <td>{item?.merchantOrderId}</td> 
  <td>{item?.orderId}</td> 
  <td>{item?.o_bal ?? '--'}</td>
  <td>{item?.amount ?? "--"}</td> 
   <td>{item?.charges ?? '--'}</td>
  <td>{item?.taxOnCharge ?? '--'}</td> 
  <td>{item?.final_amount ?? "--"}</td>
  <td>{item?.c_bal ?? '--'}</td> 
    <td>
    {item?.status === '1' && <button className="btn btn-warning">Pending</button>}
    {item?.status === '2' && <button className="btn btn-success">Success</button>}
    {item?.status === '3' && <button className="btn btn-danger">Failed</button>}
    {item?.status === '4' && <button className="btn btn-light">Refund</button>}
  </td>

   <td>{item?.user_name}</td>
          <td>{item?.userMobileNo}</td>
          <td>{item?.user_merchant_code}</td>
        
                    {/* <td><Button variant="outline-primary" onClick={() => responseEnquiry(item._id)}
                              disabled={loading || item?.approve}>
                            Enquiry
                            </Button></td> */}
                </tr>
            ))}
        </tbody>
    </table>
</div>

                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {totalCount} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            total={totalCount}
                                            current={currentPage}
                                            onChange={onChangeVal}
 
                                        />
                                    </div>
                                </div>
                            </div>
                          
                        </div>

                    </div>

                </div >
            </section>
        </>
        ) : (
          <div className="text-center mt-4">
            <h3>No data available</h3>
          </div>
        )}
       {/* // table section  */}
    </>
  )
}

export default PayInTransactionReport